import React, { useEffect, useState } from 'react';

export type CountdownTimerProps = {
  title?: string;
  seconds?: number;
  onCountdownFinished: () => void;
};

export const CountdownTimer = ({
  title = null,
  seconds = 5,
  onCountdownFinished
}: CountdownTimerProps) => {
  const [remainingSeconds, setRemainingSeconds] = useState(seconds);

  useEffect(() => {
    if (remainingSeconds <= 0) {
      onCountdownFinished();
      return;
    }

    const timerId = window.setTimeout(() => {
      setRemainingSeconds((prev) => prev - 1);
    }, 1000);

    return () => window.clearTimeout(timerId);
  }, [remainingSeconds]);

  if (remainingSeconds <= 0) {
    return null;
  }

  return (
    <div className="countdown-timer" data-testid="countdown-timer">
      {title && <div className="countdown-timer__title">{title}</div>}
      <div className="countdown-timer__number" data-testid="countdown-number">
        {remainingSeconds}
      </div>
    </div>
  );
};
